// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")

// Check if we're not on the calculate page and update checkout status
if (!window.location.href.includes("/calculate")) {
    // Запрос к серверу для обновления состояния @cart.checkout на false
    fetch('/update_checkout', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ checkout: false }),
    });
}
